import { supabase } from "../../../lib/supabase";

/**
 * Cria mensagem sintética de fallback quando a API não retorna mensagens
 * mas o metadata do chat possui informação de última mensagem.
 *
 * IMPORTANTE: Verifica se já existem mensagens reais no DB antes de criar.
 * Isso evita duplicatas quando o sync real já trouxe a mensagem.
 */
export async function createSyntheticFallback(
  rawChat: any,
  conversationDbId: string,
  remoteJid: string,
  organizationId: string,
  ownerJid: string,
): Promise<void> {
  const lastMsgText =
    rawChat.wa_lastMessageTextVote ||
    rawChat.wa_lastMessageBody ||
    rawChat.wa_lastMessageText ||
    rawChat.lastMsg ||
    rawChat.lastMessage ||
    "";
  const lastMsgTs =
    rawChat.wa_lastMsgTimestamp ||
    rawChat.lastMsgTimestamp ||
    rawChat.wa_t ||
    rawChat.timestamp;

  if (!lastMsgText || !lastMsgTs) return;

  const ts =
    lastMsgTs > 9999999999
      ? new Date(lastMsgTs).toISOString()
      : new Date(lastMsgTs * 1000).toISOString();

  // Atualiza metadados da conversa
  await supabase
    .from("chat_conversations")
    .update({
      last_message: lastMsgText,
      last_message_time: ts,
      updated_at: ts,
    })
    .eq("id", conversationDbId);

  // Verifica se já tem mensagens reais — se sim, não cria sintética
  const { count } = await supabase
    .from("chat_messages")
    .select("*", { count: "exact", head: true })
    .eq("conversation_id", conversationDbId);

  if (count && count > 0) return;

  // Detecta fromMe
  const lastSender = rawChat.wa_lastMessageSender || "";
  const lastSenderDigits = lastSender
    .replace("@s.whatsapp.net", "")
    .replace(/\D/g, "");
  const ownerDigits = ownerJid.replace(/\D/g, "");
  const isSyntheticFromMe =
    rawChat.wa_lastMessageFromMe === true ||
    rawChat.wa_lastMessageFromMe === "true" ||
    rawChat.wa_lastMessageFromMe === 1 ||
    rawChat.wa_lastMessageFromMe === "1" ||
    (lastSenderDigits && ownerDigits && lastSenderDigits === ownerDigits);

  const syntheticMsgId = `sync_${remoteJid}_${lastMsgTs}`;

  await supabase.from("chat_messages").upsert(
    {
      message_id: syntheticMsgId,
      conversation_id: conversationDbId,
      sender: isSyntheticFromMe ? "me" : "them",
      content: lastMsgText,
      message_type: "text",
      status: "delivered",
      organization_id: organizationId,
      timestamp: ts,
    },
    { onConflict: "conversation_id,message_id", ignoreDuplicates: true },
  );
}
